module.exports = __webpack_public_path__ + "static/media/atlas.fc2e4043.png";